import { SVGProps } from 'react';

export const CancelIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="3.5"
        className="fill-theme-highlight-green stroke-theme-dark-green"
      />
      <rect x="10" y="10" width="12" height="12" className="fill-theme-dark-green" />
    </svg>
  );
};
